import React, { ReactElement, useEffect, useState } from 'react';

import { Divider, Heading, Paragraph, Search } from 'elmo-elements';

import { FaqType } from '@/modules/types/helper';

export interface FaqPropsType {
  isVisible: boolean;
  content: undefined | FaqType[];
  classNamePrefix: string;
}

const Faq = ({
  isVisible,
  content,
  classNamePrefix,
}: FaqPropsType): ReactElement => {
  const [searchKeyword, setSearchKeyword] = useState('');
  const [searchResult, setSearchResult] = useState(content);

  function doSearch(faq: FaqType) {
    return (
      faq.answer.toLowerCase().includes(searchKeyword.toLowerCase()) ||
      faq.question.toLowerCase().includes(searchKeyword.toLowerCase())
    );
  }

  useEffect(() => {
    setSearchResult(content);
  }, [content]);

  useEffect(() => {
    if (content) setSearchResult(content.filter(doSearch));
  }, [searchKeyword]);

  const handleSearchChange = (value: string) => {
    setSearchKeyword(value);
  };

  return (
    <div className={`${classNamePrefix}__faq ${isVisible ? 'is-visible' : ''}`}>
      <div className={`${classNamePrefix}__faq__inner p-3`}>
        <div className={`${classNamePrefix}__faq__header`}>
          <Search
            isVisible={isVisible}
            placeholder="Enter keywords to filter FAQs"
            value={searchKeyword}
            onChange={handleSearchChange}
          />
          <div className="py-3">
            <Divider />
          </div>
          <Heading size="sm" className="mb-2">
            Top FAQs
          </Heading>
        </div>
        {searchResult?.length ? (
          <div className={`${classNamePrefix}__faq__result`}>
            <dl className="faq-list">
              {searchResult.map((faqItem, index) => (
                <div key={index}>
                  <dt>{faqItem.question}</dt>
                  <dd>{faqItem.answer}</dd>
                </div>
              ))}
            </dl>
          </div>
        ) : (
          <Paragraph>There are no FAQ available.</Paragraph>
        )}
      </div>
    </div>
  );
};

export default Faq;
